import React, { FC } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { Loader } from 'src/components/Forms/FormInputs/styled';

interface TextInputProps {
  loading?: boolean;
}

export const TextInput: FC<TextInputProps & TextFieldProps> = ({
  name = '',
  disabled,
  loading,
  ...props
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, onBlur, value } }) => (
        <TextField
          {...props}
          onBlur={onBlur}
          onChange={onChange}
          value={value || ''}
          disabled={loading || disabled}
          InputProps={{
            startAdornment: loading && <Loader size={18} />,
          }}
        />
      )}
    />
  );
};
